import type {
  ApiClientGroupMember,
  UiClientGroupMember,
  ApiClientGroup,
  UiClientGroup,
} from '../../schemas/clientGroups.schema';

export function mapClientGroupMemberFromApi(
  member: ApiClientGroupMember,
): UiClientGroupMember {
  return {
    id: member.id,
    addedAt: member.addedAt,
    clientEmail: member.client?.user?.email,
    clientName: member.client?.user?.name,
    clientOrgUserId: member.clientOrgUserId,
    clientOrganizationStatus: member.client?.status,
    clientPhoto: member.client?.user?.profilePhoto ?? null,
    clientUserId: member.client?.userId,
    groupId: member.groupId,
    status: member.status,
  };
}

export function mapClientGroupFromApi(group: ApiClientGroup): UiClientGroup {
  return {
    id: group.id,
    color: group.color,
    createdAt: group.createdAt,
    description: group.description,
    memberCount: group.memberCount ?? group.members?.length ?? 0,
    members: group.members?.map(mapClientGroupMemberFromApi),
    name: group.name,
    ownerId: group.ownerId,
    updatedAt: group.updatedAt,
  };
}
